import { Injectable, signal } from '@angular/core';

export type ToastVariant = 'success' | 'error';

export interface ToastMessage {
  id: number;
  message: string;
  variant: ToastVariant;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private nextId = 0;
  private readonly durationMs = 4500;

  readonly toasts = signal<ToastMessage[]>([]);

  success(message: string): void {
    this.push(message, 'success');
  }

  error(message: string): void {
    this.push(message, 'error');
  }

  dismiss(id: number): void {
    this.toasts.update((current) => current.filter((toast) => toast.id !== id));
  }

  private push(message: string, variant: ToastVariant): void {
    const id = this.nextId++;
    this.toasts.update((current) => [...current, { id, message, variant }]);

    setTimeout(() => this.dismiss(id), this.durationMs);
  }
}
